import * as $ from 'jquery'

const siteurl = $('#Siteurl').attr('content')
const chosenClass = 'chosen-store'
const noteClass = 'jb-note'
const buttonClass = 'btn-set-dir'
window.jbsite = window.jbsite || {}

let saved_store_id

function handleChosen(store_id) {
  clearPreviouslyChosen()
  saveChosen(store_id)
}

function clearPreviouslyChosen() {
  $(`.${chosenClass}`)
    .find(`.${noteClass}`)
      .remove()
    .end()
  .removeClass(chosenClass)
}

function saveChosen(store_id) {
  const endpoint = `${siteurl}/?qcAC=0&my-nearest=1&store_id=${store_id}`
  $.post(endpoint, {store_id}, (data, msg, xhr) => savedCallback(store_id, msg))
}

function savedCallback(store_id, msg) {
  if (msg !== 'success') return false
  $('.lpr-location')
    .filter(`[data-id="${store_id}"]`)
      .find('.list-unstyled')
        .addClass(chosenClass)
        .find('.lpr-location-misc2')
          .find(`.${noteClass}`).remove()
          .end()
        .append(`<strong class="${noteClass}">Chosen as your nearest store</strong>`)
}

// needs to be available for store locator buttons
window.jbsite.handle_dir_set = handleChosen



// WEBPACK FOOTER //
// ./sportspower/assets/es6/init-nearest-store.js